import React, { createContext, useContext, useReducer } from "react";
import { ACTION_TYPES, PrestacaoContasReducer, PrestacaoContasState } from "./prestacao-contas-reducer";
import { PaginationResponse } from "models/pagination-response";
import { IPrestacaoContasPagedResponse } from "models/response/prestacao-contas-paged-response";

const PrestacaoContasContext = createContext<PrestacaoContasState | undefined>(undefined);
const PrestacaoContasContextDispatchContext = createContext({} as any);

const PrestacaoContasProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(PrestacaoContasReducer, {
        prestacoesContas: new PaginationResponse<IPrestacaoContasPagedResponse>([], 0, 1, 10, 0),
        prestacaoContasPagedRequest: { page: 0, pageSize: 10 },
        tipos: [],
        ultimaAtualizacao: null,
        totais: { total: 0, emExecucao: 0, finalizados: 0 },
        loading: false,
        error: null
    } as PrestacaoContasState);

    return (
        <PrestacaoContasContext.Provider value={state}>
            <PrestacaoContasContextDispatchContext.Provider value={dispatch}>
                {children}
            </PrestacaoContasContextDispatchContext.Provider>
        </PrestacaoContasContext.Provider>
    );
}

const usePrestacaoContasState = () => {
    const context = useContext(PrestacaoContasContext);
    if (context === undefined) {
        throw new Error('usePrestacaoContasState must be used within a PrestacaoContasProvider');
    }
    return context;
}

const usePrestacaoContasDispatch = () => {
    const context = useContext(PrestacaoContasContextDispatchContext);
    if (context === undefined) {
        throw new Error('usePrestacaoContasDispatch must be used within a PrestacaoContasProvider');
    }
    return context;
}

export { PrestacaoContasProvider, usePrestacaoContasState, usePrestacaoContasDispatch, ACTION_TYPES };
